/**
 * @file The title a report shows for one query: its `NAMED_QUERY_PRESENTATION`
 * title with `<team>` filled by the team noun, or the query id when the
 * registry does not name the query (an old run may hold one). Consumers: the
 * React run view and the PDF, which pass the run's frozen `teamNoun` or
 * `ANALYTICS_DEFAULT_TEAM_NOUN`, so a reopened run keeps the noun it ran with.
 */
import type { NamedQueryId } from './Analytics.NamedQuery.types';
import { NAMED_QUERY_PRESENTATION } from './Analytics.NamedQueryPresentation.types';
import type { NamedQueryPresentation } from './Analytics.NamedQueryPresentation.types';

const PRESENTATIONS: Partial<Record<NamedQueryId, NamedQueryPresentation>> = NAMED_QUERY_PRESENTATION;

export const analyticsReportQueryTitle = (query: NamedQueryId, teamNoun: string): string =>
  PRESENTATIONS[query]?.title.replace('<team>', teamNoun) ?? query;
